<template v-if="actorInfo">
    <dl class="aeg-description-list">
        <template v-if="emails">
            <dt class="aeg-description-list__term">Email:</dt>
            <dd class="aeg-description-list__description"> {{ emails }} - <vl-link @click.prevent="editActorEmails">aanpassen</vl-link></dd>
            <aeg-edit-actor-mails :actor="actorInfo" :modal-id="modalId" @on-save="updateActorEmails" />
        </template>
        <template v-if="actorInfo.service && !isCitizen">
            <dt class="aeg-description-list__term">{{ actorInfo.service }}-saldo:</dt>
            <dd class="aeg-description-list__description">€ {{ formatAmount(actorInfo.amount) }}</dd>
        </template>
    </dl>
    
    <template v-if="invoiceSettings && invoiceSettings.length > 0">
        <vl-u-spacer mod-small />
        <vl-title tag-name="h4">Factuurinstellingen</vl-title>
        <template v-for="setting in invoiceSettings" :key="setting.invoiceSettingsId">
            <dl class="aeg-description-list">
                <dt class="aeg-description-list__term">InvoiceSettingId:</dt>
                <dd class="aeg-description-list__description">{{ setting.invoiceSettingsId }}</dd>
                
                <template v-if="setting.invoiceReference">
                    <dt class="aeg-description-list__term">Eigen referentie:</dt>
                    <dd class="aeg-description-list__description">{{ setting.invoiceReference }}</dd>
                </template>
                
                <template v-if="setting.forTheAttentionOf">
                    <dt class="aeg-description-list__term">T.a.v.:</dt>
                    <dd class="aeg-description-list__description">{{ setting.forTheAttentionOf }}</dd>
                </template>
                
                <dt class="aeg-description-list__term"></dt>
                <dd class="aeg-description-list__description">
                    <vl-link @click.prevent="editSettings(setting)">aanpassen</vl-link>
                </dd>
            </dl>
            <aeg-edit-invoice-settings 
                :invoice-settings="setting" 
                :modal-id="getModalId(setting.invoiceSettingsId)"
                @on-save="handleInvoiceSettingsSaved" />
            <vl-u-spacer mod-small />
        </template>
    </template>
</template>
<template v-else>
    Niet actief
</template>
